module.exports = __webpack_public_path__ + "animoji3.fb7b6e20bf.png";